import React from 'react';
import { useTranslation } from 'react-i18next';

import "./CopyToast.scss";

import { ReactComponent as CopyIcon } from "static/icons/copy-icon.svg";

const CopyToast = () => {
  const { t } = useTranslation();
  
  return (
    <div className="copy-toast">
      <div className="copy-toast__icon-container">
        <CopyIcon className="copy-toast__icon" />
      </div>

      <div className="copy-toast__text">
        {t('copied_to_clipboard')}
      </div>
    </div>
  );
};

export default CopyToast;
